import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnChanges, OnDestroy, OnInit, SimpleChanges, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import { TranslateService } from '@codeandweb/ngx-translate';

import { Subscription } from 'rxjs';

import { DropdownModule } from '@app/primeng-overrides/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';

import { ControlValueAccessorBase } from '@app/_helpers/control-value-accessor-base';
import { StatutRecolement } from '../texte.model';
import { SiteService } from '@app/site/site.service';
import { ListesGeneriquesService, StatutDefinition } from '@app/_global/listes-generiques.service';

@Component({
	selector: 'statut-recolement-selector',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => StatutRecolementSelectorComponent),
			multi: true
		}
	],
	template: `
		<p-dropdown
			[name]="name"
			[required]="required"
			[options]="options"
			[(ngModel)]="value"
			[filter]="options.length > 5"
			filterBy="rub_nom"
			[readonly]="readonly"
			[ngClass]="{'p-readonly': readonly}"
			[placeholder]="_placeholder"
			[disabled]="disabled"
			[showClear]="nullOption"
			[virtualScroll]="true"
			[virtualScrollItemSize]="virtualScrollItemSize"
			optionValue="sta_code"
			optionLabel="sta_libelle"
			appendTo="body"
			[styleClass]="styleClass"
		>
		</p-dropdown>
	`
})
export class StatutRecolementSelectorComponent extends ControlValueAccessorBase<StatutRecolement> implements OnInit, OnChanges, OnDestroy  {

	@Input() name: string;
	@Input('value') innerValue: StatutRecolement;
	@Input() required: boolean;
	@Input() readonly: boolean;
	@Input() placeholder: string;
	@Input() nullIfInvalid: boolean;
	@Input() nullOption: boolean;
	@Input() disabled: boolean;
	@Input() unavailableRubriques?: number[];
	/** Status interdits en écriture (readonly: false) */
	@Input() excludedStatuses?: StatutRecolement[]; 
	@Input() fam_id: number;
	@Input() thm_id: number;
	@Input() styleClass?: string

	_placeholder: string = 'Sélectionnez';

	options: StatutDefinition[] = [];

	subscriptionLangChange?: Subscription;

	// TODO on devrait centraliser ça
	virtualScrollItemSize: number = 18;

	constructor(
		private siteService: SiteService,
		private translateService: TranslateService,
		private listeGeneriqueService: ListesGeneriquesService
	) {
		super();

		if (this.placeholder == undefined) {
			this.subscriptionLangChange = this.translateService.onLangChange.subscribe(() => {
				this._placeholder = translateService.instant('common.selector_placeholder');
			});
		}
	}

	ngOnInit() {
		if (this.placeholder != undefined) {
			this._placeholder = this.placeholder;
		}

		let statuts = structuredClone(this.listeGeneriqueService.definitionsStatus);

		if (this.excludedStatuses != undefined && !this.readonly) {
			statuts = statuts.filter((info: StatutDefinition) => !this.excludedStatuses!.includes(info.sta_code));
		}

		this.options = statuts;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.excludedStatuses) {
			let statuts = structuredClone(this.listeGeneriqueService.definitionsStatus);

			if (Array.isArray(changes.excludedStatuses.currentValue)) {
				statuts = statuts.filter((info: StatutDefinition) => !changes.excludedStatuses.currentValue.includes(info.sta_code));
			}

			this.options = statuts;
		}
	}

	ngOnDestroy(): void {
		this.subscriptionLangChange?.unsubscribe();
	}

}


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		AutoCompleteModule,
		DropdownModule
	],
	exports: [StatutRecolementSelectorComponent],
	declarations: [StatutRecolementSelectorComponent]
})
export class StatutRecolementSelectorModule { }
